// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogDuplicationForm from "./CatalogDuplicationForm.res.js";
import * as CatalogDuplicationFormMutations from "./CatalogDuplicationFormMutations.res.js";

function CatalogDuplicationFormPageActions(props) {
  let duplicateProduct = CatalogDuplicationFormMutations.useDuplicateProduct();
  let duplicateVariant = CatalogDuplicationFormMutations.useDuplicateVariant();
  let tmp;
  tmp = props.duplicationMode === "Product" ? duplicateProduct : duplicateVariant;
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx(CatalogDuplicationForm.SubmitButton.make, {
      label: I18n.t("Duplicate"),
      onSubmit: tmp
    }),
    space: "small"
  });
}

let make = React.memo(CatalogDuplicationFormPageActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
